import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-field-label',
  templateUrl: './field-label.component.html',
  styleUrls: ['./field-label.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class FieldLabelComponent {
  @Input() label = '';
  @Input() required = false;
  @Input() tooltip = '';
  @Input() size = 10;
}
